import styled from "styled-components";
import colours from "styles/colours";
import { fontWeights } from "styles/fonts";

export const AppliedFiltersContainer = styled.div`
  display: flex;
  align-content: center;
  margin-bottom: 8px;
`;

export const AppliedFilterTagsList = styled.div`
  display: flex;
  gap: 10px;
  flex-grow: 1;
  flex-wrap: wrap;
  align-content: center;

  & p {
    font-weight: ${fontWeights.semiBold};
  }
`;

export const AppliedFilterTag = styled.div`
  border: 1px solid ${colours.elexonBlue};
  border-radius: 23px;
  color: ${colours.elexonBlue};
  padding: 0 10px;
  line-height: 1.7em;
`;

export const FiltersModalSection = styled.div`
  margin-bottom: 1em;
`;
